import { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
// userflow.js is dynamically imported below (post-auth, inside useEffect)
import { useAuth } from '@bb/session-manager';

import {
  SetUserFlowIsEnabled,
  SetUserFlowToken,
  SetUserHash,
} from './redux/actions/userflowActions';
import { GetUserHash } from './utils/requests';

const UserFlowManager = ({ children }) => {
  const { config } = useAuth();

  const dispatch = useDispatch();

  useEffect(() => {
    if (config && config.userFlowEnabled && config.userflowToken) {
      GetUserHash()
        .then(async (data) => {
          if (data && Object.keys(data).length > 0) {
            const { hash } = data;

            dispatch(SetUserHash(hash));
            dispatch(SetUserFlowIsEnabled(config.userFlowEnabled));
            dispatch(SetUserFlowToken(config.userflowToken));

            // Defer userflow.js (~9 KB) until post-auth — keeps it out of the index chunk
            const { default: userflow } = await import('userflow.js');

            userflow.init(config.userflowToken);
            userflow
              .identify(hash)
              .then(() => console.log('Connected to userflow'))
              .catch((err) =>
                console.log('Failed to identify user with userflow with error:', err)
              );
            userflow
              .group(window.location.hostname.split('.')[0])
              .then(() => 'Userflow group initialized')
              .catch((err) =>
                console.error('Failed to assign userflow group with error:', err)
              );
          }
        })
        .catch((err) =>
          console.error(
            'Failed to retrieve user information tracking data with error:',
            err
          )
        );
    }
  }, [config]);

  return children;
};

UserFlowManager.propTypes = {
  children: PropTypes.any,
};

export default UserFlowManager;
